import { render } from "./QuickListeningTest.vue?vue&type=template&id=3cc95dd2&scoped=true"
import script from "./QuickListeningTest.vue?vue&type=script&lang=js"
export * from "./QuickListeningTest.vue?vue&type=script&lang=js"

import "./QuickListeningTest.vue?vue&type=style&index=0&id=3cc95dd2&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cc95dd2"]])

export default __exports__